import React from 'react';
import {useField} from 'formik';
import {useIntl} from 'react-intl';
import InputText from '../../../../common/components/ui/InputText';

const FieldPassword = () => {
  const intl = useIntl();
  const labelText = intl.formatMessage({
    id: 'login-form-password',
    defaultMessage: 'Password'
  });
  const placeholder = intl.formatMessage({
    id: 'default-placeholder',
    defaultMessage: 'Write here'
  });
  const [field, meta] = useField<string>({name: 'password'});

  return (
    <InputText
      {...field}
      {...meta}
      type={'password'}
      variant={'full'}
      id={field.name}
      label={labelText}
      defaultValue={field.value}
      placeholder={placeholder}
    />
  );
};

export default FieldPassword;
